import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  dashboardPath: (dashboard) => `api/Dashboard/${dashboard}`,
  dashboardV2Path: (type, dashboard) => `api/CMSv2/${type}Dashboard/${dashboard}`,
};

export const fetchDashboard = (dashboard) => authFetch.get(routes.dashboardPath(dashboard));
export const fetchDashboardV2 = (type, dashboard) => authFetch.get(routes.dashboardV2Path(type, dashboard));
export const fetchDashboardV2simple = (type, dashboard) => makeRequest(authFetch.get(routes.dashboardV2Path(type, dashboard)));
export const fetchDashboardDrilldown = (dashboard, query) => authFetch.get(`${routes.dashboardPath(dashboard)}${query}`);
export const fetchDashboardDrilldownV2 = (type, dashboard, query) => authFetch.get(`${routes.dashboardV2Path(type, dashboard)}${query}`);
export const fetchDashboardDrilldownV2simple = (type, dashboard, query) => makeRequest(authFetch.get(`${routes.dashboardV2Path(type, dashboard)}${query}`));

